export const ERROR_TECNICO = "mensaje-0";
export const GRACIAS = "gracias";
